import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { ExplorerJumpIn } from "./ExplorerJumpIn";
import { DownloadButton } from "../../DownloadButton";
import { Modal } from "../Modal";
import { Content, ImageContainer, StyledDescription, StyledTitle, } from "./DownloadModal.styled";
function DownloadModal(props) {
    const { title, description, buttonLabel, open, onClose, onDownloadClick, ...modalProps } = props;
    const handleClose = useCallback((event) => {
        if (onClose) {
            onClose(event);
        }
    }, [onClose]);
    return (_jsx(Modal, { ...modalProps, open: open, size: "tiny", title: " " // this is to move the close button to the right
        , onClose: handleClose, children: _jsxs(Content, { children: [_jsx(ImageContainer, { children: _jsx(ExplorerJumpIn, {}) }), _jsx(StyledTitle, { variant: "h2", children: title }), _jsx(StyledDescription, { variant: "body1", children: description }), _jsx(DownloadButton, { label: buttonLabel, onClick: onDownloadClick })] }) }));
}
export { DownloadModal };
//# sourceMappingURL=DownloadModal.js.map